const YOUTUBE_API_KEY = 'AIzaSyAimM3FIehnFk1MPunKWwylJaGMiFYIokQ';
const BASE_URL = 'https://www.googleapis.com/youtube/v3';

export interface YouTubeSearchResult {
  id: {
    kind: string;
    videoId: string;
  };
  snippet: {
    title: string;
    description: string;
    thumbnails: {
      medium: {
        url: string;
      };
    };
  };
}

export const searchVideos = async (query: string): Promise<YouTubeSearchResult[]> => {
  if (!query.trim()) {
    return [];
  }

  try {
    const response = await fetch(
      `${BASE_URL}/search?part=snippet&maxResults=24&q=${encodeURIComponent(
        query
      )}&type=video&key=${YOUTUBE_API_KEY}`
    );

    if (!response.ok) {
      throw new Error('Failed to search videos');
    }

    const data = await response.json();
    
    // Filter out any results that don't have a valid videoId
    const validResults = (data.items || []).filter((item: any) => {
      return item?.id?.kind === 'youtube#video' && item?.id?.videoId;
    });
    
    return validResults;
  } catch (error) {
    console.error('Error searching videos:', error);
    return [];
  }
};

export const getVideoUrl = (videoId: string): string => {
  if (!videoId) {
    console.error('Invalid video ID:', videoId);
    return '#'; // Return a safe fallback URL
  }
  return `https://www.youtube.com/watch?v=${videoId}`;
};